"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PremiumContentMetadata = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * Container of all metadata which should be displayed on Premium Content in a web player.
 */
function PremiumContentMetadata() {
    // TODO: Add relevant metadata, if any.
    return (0, jsx_runtime_1.jsx)("div", {});
}
exports.PremiumContentMetadata = PremiumContentMetadata;
//# sourceMappingURL=PremiumContentMetadata.js.map